export default {"src":"/_next/static/media/startup-logo1.cdf17d89.svg","height":108,"width":546,"blurWidth":0,"blurHeight":0};